import { render, staticRenderFns } from "./KelasMakMinButton.vue?vue&type=template&id=3ef2dd66&"
import script from "./KelasMakMinButton.vue?vue&type=script&lang=js&"
export * from "./KelasMakMinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports